"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2631],{

/***/ 7277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5861);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6066);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1548);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3873);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_6__);








function AppSlider(param) {
    let { list , title , directionLTR , width , numbers , titleMargin , sliderPad , pointer , marquee  } = param;
    const settings = {
        infinite: Boolean(marquee),
        speed: marquee ? 4000 : 1500,
        slidesToShow: numbers ? numbers : 5,
        slidesToScroll: 1,
        initialSlide: 0,
        autoplay: true,
        autoplaySpeed: marquee ? 0 : 2000,
        centerMode: false,
        arrows: false,
        easing: marquee ? "linear" : "ease",
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
        sx: {
            padding: sliderPad ? sliderPad : "0"
        },
        className: "container",
        children: [
            title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                style: {
                    position: "relative",
                    display: "flex",
                    justifyContent: "center",
                    padding: "8px 0",
                    margin: titleMargin ? titleMargin : "auto"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        sx: {
                            background: "white",
                            padding: "0 8px",
                            zIndex: 1,
                            fontWeight: "bold",
                            fontSize: {
                                xs: "24px",
                                md: "32px"
                            }
                        },
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                        style: {
                            position: "absolute",
                            height: 1,
                            width: "100%",
                            background: "lightgray",
                            top: "calc(50% + 0.5px)",
                            zIndex: 0
                        }
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                style: {
                    padding: "8px 0",
                    transform: directionLTR ? "rotate(180deg)" : "rotate(0deg)"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    ...settings,
                    children: list.map((m, i)=>{
                        var ref;
                        const frameWidth = width ? width : 140;
                        const frameHeight = 140;
                        const img = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                            width: frameWidth,
                            height: frameHeight,
                            src: m.icon,
                            alt: m.name,
                            style: {
                                width: "100%",
                                height: "100%",
                                border: "none",
                                outline: "none",
                                transform: directionLTR ? "rotate(180deg)" : "rotate(0deg)",
                                objectFit: "contain",
                                cursor: pointer ? "pointer" : "normal"
                            },
                            className: "app-slider-img",
                            loading: "lazy"
                        });
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                style: {
                                    width: frameWidth,
                                    height: frameHeight,
                                    margin: "0 auto",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "10px",
                                    boxSizing: "border-box"
                                },
                                children: (m === null || m === void 0 ? void 0 : (ref = m.redirectLink) === null || ref === void 0 ? void 0 : ref.length) > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_6___default()), {
                                    href: m.redirectLink,
                                    rel: "preload",
                                    children: img
                                }) : img
                            })
                        }, i);
                    })
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (AppSlider);


/***/ }),

/***/ 1985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PartnerSliders; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _AppSlider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7277);



const normalizeKey = (value)=>String(value !== null && value !== void 0 ? value : "").trim().toUpperCase().replace(/\s+/g, "_");
const ALLOWED_PARTNERS = new Set([
    "HDFC_P",
    "SBI_CC",
    "ICICI_CC",
    "AXIS_CK",
    "INDUS_CC",
    "YES_CC",
    "IDFC_PL",
    "KSECURITY",
    "MOTILAL_OSWAL",
    "UPSTOX",
    "ANGEL_ONE",
    "BAJAJ_EMI",
    "CLICKPE",
    "ADITYA_LOAN",
    "POONAWALLA_FINCORP",
    "DBS",
    "AIRTEL_XSTREAM",
    "AUSFB_CC",
    "EQUITASC",
    "BHARATPL",
    "INCRED",
    "KREDITBEE"
].map(normalizeKey));
/** Shown even if the products API omits them (regulatory lending-partner disclosure). */ const REQUIRED_LENDING_PARTNERS = [
    {
        name: "KreditBee",
        icon: "/assets/images/home/partners/kbnbfc.png",
        redirectLink: "https://www.kbnbfc.in/"
    }
];
function mergeRequiredLendingPartners(list) {
    const merged = [
        ...list
    ];
    const codes = new Set(merged.map((item)=>normalizeKey(item.name)));
    for (const required of REQUIRED_LENDING_PARTNERS){
        const key = normalizeKey(required.name);
        if (codes.has(key)) {
            const idx = merged.findIndex((item)=>normalizeKey(item.name) === key);
            if (idx >= 0) {
                merged[idx] = {
                    ...merged[idx],
                    icon: required.icon,
                    redirectLink: required.redirectLink
                };
            }
            continue;
        }
        merged.push(required);
        codes.add(key);
    }
    return merged;
}
function PartnerSliders(param) {
    let { title , titleMargin , width =240 , numbers =4  } = param;
    const [dynamicList, setDynamicList] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [loaded, setLoaded] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let cancelled = false;
        (async ()=>{
            let list = [];
            try {
                const res = await fetch("/api/productsForGp");
                if (res.ok) {
                    const data = await res.json();
                    const products = Array.isArray(data === null || data === void 0 ? void 0 : data.products) ? data.products : [];
                    const seen = new Set();
                    list = products.filter((p)=>{
                        return (p === null || p === void 0 ? void 0 : p.productImage) && (p === null || p === void 0 ? void 0 : p.code);
                    }).filter((p)=>{
                        const codeKey = normalizeKey(p.code);
                        const nameKey = normalizeKey(p.name);
                        return ALLOWED_PARTNERS.has(codeKey) || ALLOWED_PARTNERS.has(nameKey);
                    }).filter((p)=>{
                        const codeKey = normalizeKey(p.code);
                        if (!codeKey || seen.has(codeKey)) return false;
                        seen.add(codeKey);
                        return true;
                    }).map((p)=>({
                            name: p.name || p.code,
                            icon: p.productImage,
                            redirectLink: ""
                        }));
                }
            } catch (e) {
            // API failed; still show required lending partners below
            }
            const merged = mergeRequiredLendingPartners(list);
            if (!cancelled) setDynamicList(merged);
            if (!cancelled) setLoaded(true);
        })();
        return ()=>{
            cancelled = true;
        };
    }, []);
    const { topRow , bottomRow  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        const half = Math.ceil(dynamicList.length / 2);
        return {
            topRow: dynamicList.slice(0, half),
            bottomRow: dynamicList.slice(half)
        };
    }, [
        dynamicList
    ]);
    if (!loaded || dynamicList.length === 0) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AppSlider__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                list: topRow,
                directionLTR: true,
                width: width,
                numbers: numbers,
                title: title,
                titleMargin: titleMargin
            }),
            bottomRow.length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AppSlider__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                list: bottomRow,
                width: width,
                numbers: numbers
            }) : null
        ]
    });
}


/***/ }),

/***/ 9584:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6886);
/* harmony import */ var _PartnerSliders__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1985);



function Brand() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
        container: true,
        sx: {
            position: "relative",
            minHeight: {
                xs: "30vh",
                md: "50vh"
            },
            justifyContent: "space-around",
            flexDirection: "column",
            padding: {
                xs: "48px 0",
                md: "60px 0"
            },
            maxWidth: "1440px",
            margin: "auto"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PartnerSliders__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            title: "Our Financial Partners",
            titleMargin: "25px auto",
            width: 240,
            numbers: 4
        })
    });
}
/* harmony default export */ __webpack_exports__["default"] = (Brand);


/***/ })

}]);